module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-wrapper"
  }, [_vm._m(0), _vm._v(" "), _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-default margin-bottom-0px"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Link List")]), _vm._v(" "), _c('div', {
    staticClass: "action-button pull-right"
  }, [_c('div', {
    staticClass: "form-group col-xs-12 col-sm-12",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('label', {
    attrs: {
      "for": "date-to"
    }
  }), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-primary",
    attrs: {
      "to": "Link-addOrUpdate"
    }
  }, [_vm._v("Add Link")])], 1)])]), _vm._v(" "), (_vm.actionInProgress) ? _c('div', {
    staticClass: "loader"
  }, [_c('img', {
    attrs: {
      "src": "/static/assets/loader/nivi-loader.svg"
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "box-footer no-border"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('vue-good-table', {
    attrs: {
      "mode": "remote",
      "styleClass": "vgt-table good-table condensed striped",
      "columns": _vm.columns,
      "rows": _vm.linkData,
      "totalRows": _vm.linkDataCount,
      "pagination-options": {
        enabled: true,
        perPage: _vm.tableQueryParams.perPage,
        setCurrentPage: _vm.tableQueryParams.page
      }
    },
    on: {
      "on-page-change": _vm.onPageChange,
      "on-sort-change": _vm.onSortChange,
      "on-column-filter": _vm.onColumnFilter,
      "on-per-page-change": _vm.onPerPageChange
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function(props) {
        return [_vm._t("default", null, {
          "props": props
        }), _vm._v(" "), (props.column.field == 'createdAt') ? _c('span', [_vm._v("\n                        " + _vm._s(_vm.formatDate(props.formattedRow[props.column.field], 'd/M/Y hh:ss')) + "\n                      ")]) : (props.column.field == 'updatedAt') ? _c('span', [_vm._v("\n                        " + _vm._s(_vm.formatDate(props.formattedRow[props.column.field], 'd/M/Y hh:ss')) + "\n                      ")]) : (props.column.field == 'is_active') ? _c('span', [(props.formattedRow[props.column.field]) ? _c('span', {
          staticClass: "badge badge-pill btn-success",
          staticStyle: {
            "cursor": "pointer"
          },
          on: {
            "click": function($event) {
              return _vm.showDeleteConfirmationPopup(props.row, props.index)
            }
          }
        }, [_vm._v("Active")]) : _vm._e(), _vm._v(" "), (!props.formattedRow[props.column.field]) ? _c('span', {
          staticClass: "badge badge-pill btn-danger",
          staticStyle: {
            "cursor": "pointer"
          },
          on: {
            "click": function($event) {
              return _vm.showDeleteConfirmationPopup(props.row, props.index)
            }
          }
        }, [_vm._v("Inactive")]) : _vm._e()]) : (props.column.field == 'copy') ? _c('span', [_c('input', {
          staticClass: "btn btn-primary btn-sm",
          attrs: {
            "type": "button",
            "value": "Copy URL"
          },
          on: {
            "click": function($event) {
              return _vm.copyLink(props.row)
            }
          }
        })]) : (props.column.field == 'edit') ? _c('span', [_c('router-link', {
          attrs: {
            "to": ("Link-addOrUpdate?linkId=" + (props.row.id))
          }
        }, [_c('i', {
          staticClass: "fa fa-pencil",
          attrs: {
            "aria-hidden": "true"
          }
        })])], 1) : _c('span', [_vm._v(_vm._s(props.formattedRow[props.column.field]))])]
      }
    }], null, true)
  }, [_c('div', {
    attrs: {
      "slot": "emptystate"
    },
    slot: "emptystate"
  }, [_c('nv-empty-state', {
    attrs: {
      "icon": "fa-link",
      "title": "No links found",
      "hint": "Try changing the filters, or create a new link.",
      "action-label": "Create link",
      "action-to": "/link-addOrUpdate"
    }
  })], 1), _vm._v(" "), _c('template', {
    slot: "loadingContent"
  })], 2)], 1)])])])])])]), _vm._v(" "), (_vm.isDeleteConfirmationVisible) ? _c('deleteConfirmationModal', {
    attrs: {
      "isDeleteConfirmationVisible": _vm.isDeleteConfirmationVisible,
      "confirmationMessage": _vm.confirmationMessage,
      "actionToBePerformed": _vm.actionToBePerformed
    },
    on: {
      "close": _vm.closeConfirmationModal,
      "deleteLink": _vm.deleteLink,
      "deactiveLink": _vm.deactiveLink,
      "activeLink": _vm.activeLink
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "pagination-container"
  }, [(_vm.pageCount > 0) ? _c('paginate', {
    attrs: {
      "page-count": _vm.pageCount,
      "click-handler": _vm.getDataForSelectedPage,
      "prev-text": 'Prev',
      "next-text": 'Next',
      "container-class": 'pagination'
    },
    model: {
      value: (_vm.page),
      callback: function($$v) {
        _vm.page = $$v
      },
      expression: "page"
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.loading) ? _c('BlockUI', [_c('i', {
    staticClass: "fa fa-cog fa-spin fa-3x fa-fw"
  }), _c('br'), _vm._v("Please wait...")]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content-header"
  }, [_c('h1', [_vm._v("\n      Link Management\n    ")]), _vm._v(" "), _c('ol', {
    staticClass: "breadcrumb"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-dashboard"
  }), _vm._v(" Home")])]), _vm._v(" "), _c('li', [_vm._v("Link")]), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_vm._v("Link List")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-246acdae","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/link-management/linkList.vue
// module id = aapx
// module chunks = 1